export default class {
    constructor ($translate, lodash, FORM_REPEAT_ENUM, FORMS_TYPE_ENUM, FORMS_DISPLAY_TYPE_ENUM, FORM_SITE_ACCESS_ENUM,
                 TokenService, SiteService, PrivilegeService) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.FORM_REPEAT_ENUM = FORM_REPEAT_ENUM;
        this.FORMS_TYPE_ENUM = FORMS_TYPE_ENUM;
        this.FORMS_DISPLAY_TYPE_ENUM = FORMS_DISPLAY_TYPE_ENUM;
        this.FORM_SITE_ACCESS_ENUM = FORM_SITE_ACCESS_ENUM;
        this.PrivilegeService = PrivilegeService;
        this.SiteService = SiteService;
        this.defaultLanguage = TokenService.getCompanyLanguage();
    }

    getRepeatOptions () {
        return [
            { value: 1, label: this.$translate.instant('form.Once') },
            { value: 2, label: this.$translate.instant('form.Twice') },
            { value: 3, label: this.$translate.instant('form.Three times') },
            {
                value: `'${this.FORM_REPEAT_ENUM.KEYS.UNLIMITED}'`,
                label: this.FORM_REPEAT_ENUM.LABELS.UNLIMITED
            }
        ];
    }

    getRepeatForModel (radioButtonValue) {
        if (radioButtonValue === this.FORM_REPEAT_ENUM.KEYS.UNLIMITED) {
            return 0; // will be converted to NULL on api level
        }
        return radioButtonValue;
    }

    isCertificationForm (model) {
        return model.type === this.FORMS_TYPE_ENUM.KEYS.CERTIFICATION;
    }

    isCertificationFeedbackForm (model) {
        return model.type === this.FORMS_TYPE_ENUM.KEYS.CERTIFICATION_FEEDBACK;
    }

    isEvaluationForm (model) {
        return model.type === this.FORMS_TYPE_ENUM.KEYS.FORM_360_FEEDBACK;
    }

    isSurveyForm (model) {
        return model.type === this.FORMS_TYPE_ENUM.KEYS.SURVEY;
    }

    finalizeModelBeforeSave (model) {
        if (!this.isCertificationForm(model)) {
            model.timeToAnswer = null;
            model.minimumPassRate = null;
            model.isRoomRequired = 0;
            model.displayType = this.FORMS_DISPLAY_TYPE_ENUM.KEYS.ONE_PAGE;
            model.randomizeQuestions = 0;
            model.isResultShown = 0;
            model.isCorrectAnswerShown = 0;
        }

        if (!this.lodash.has(model.formI18ns, this.defaultLanguage)) {
            this.lodash.set(model, `formI18ns.${this.defaultLanguage}.name`, '');
        }
    }

    canManageForm (form) {
        if (this.PrivilegeService.isCompanyAdmin() || !form || !form.hasOwnProperty('id')) {
            return true;
        }

        const isAllSites = form.siteAccess === this.FORM_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
        if (isAllSites) {
            return this.PrivilegeService.isSiteAccessForAllUsers() && this.PrivilegeService.canManageForms();
        }

        if (!form.sites) {
            return false;
        }

        const privileges = this.PrivilegeService.getFormManagePrivileges();

        if (this.PrivilegeService.isSiteAccessForAllUsers()) {
            // if user has manage privilege in any site then allow user to manage form data
            return form.sites.filter(site => this.SiteService.hasPrivilegeInSite(site.id, privileges)).length > 0;
        }

        // if user has manage privilege and there is only one access site
        return form.sites.length === 1 && form.sites.filter(site => this.SiteService.hasPrivilegeInSite(site.id, privileges)).length > 0;
    }

    hasNonCertForms (forms) {
        const nonCertForms = this.lodash.filter(forms, form => form.type !== this.FORMS_TYPE_ENUM.KEYS.CERTIFICATION);
        return nonCertForms.length;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/form/index.js